module.exports = __webpack_public_path__ + "img/thumbnail_Meerkat_m_normal.b59b5a11.png";